import { NotificationMessage } from '../notifications.model';

export interface NotificationsTrayModel {
  expanded: boolean;
  hidden: boolean;
  items?: NotificationMessage[];
  unread?: number;
  moduleName?: string;
}
